import { useEffect } from 'react'
import { useAppStore } from '@/stores'
import { nodeApi } from '@/services/api'

/** 每个会话只向后端问一次，多个 Tabbar 实例（每个 tab 页各挂一个）共用这一次 */
let probed = false

/**
 * 节点是否还有在售档位 —— 供底部 tab 决定第二个 tab 是「节点」还是「短剧」。
 *
 * 三档全部下架后节点页整页变成「MC 联盟短剧出海」预告，tab 再叫「节点」就名不副实。
 * Tabbar 挂在每个一级页面上，而档位数据只有首页和节点页会拉，用户直接打开 /stake
 * 时 tab 无从得知 —— 所以这里自己探测一次（/node/tiers 免登录、配置快照直出，开销很小），
 * 结果写进持久化的 app store：下次冷启动直接用上次的值，不会先画「节点」再跳成「短剧」。
 * 首页与节点页拿到档位后也会写同一个字段，运营中途上下架时最迟在用户回到这两页时纠正。
 *
 * 返回 null 表示本机从未探测成功过（首次访问、请求还没回来），调用方按「节点」兜底。
 */
export function useNodeSaleStatus(): boolean | null {
  const nodeOnSale = useAppStore((s) => s.nodeOnSale)
  const setNodeOnSale = useAppStore((s) => s.setNodeOnSale)

  useEffect(() => {
    if (probed) return
    probed = true
    nodeApi
      .tiers()
      .then((res) => {
        if (res.success) setNodeOnSale((res.data?.list ?? []).length > 0)
      })
      .catch(() => {
        // 探测失败保留上次持久化的值；下次会话再试。这里失败不该弹任何提示 —— 用户并没有做任何操作
        probed = false
      })
  }, [setNodeOnSale])

  return nodeOnSale
}
